import { drawersBridge, apiBridge } from '@gto/gw-store'
import { Store } from 'vuex'

export const connectXstateStore = (store: Store) => {
  drawersBridge.on('drawerOpened', event => {
    if (event.drawer.id === 'uploads') {
      store.dispatch('globals_drawer', {
        open: true,
        id: 'upload-boxes',
        tab: event.drawer.tab,
      })
    }
  })

  drawersBridge.on('drawerToggled', event => {
    if (event.drawer.id === 'uploads') {
      store.dispatch('globals_drawer_toggle', {
        id: 'upload-boxes',
        tab: event.drawer.tab,
      })
    }
  })

  apiBridge.on('logout', () => {
    store.dispatch('api_logout')
  })
}
